import { Component, OnInit } from '@angular/core';
import { SystemSettingService } from '@app/api/systemsettting.service';

@Component({
  selector: 'meu-app-home-page-video',
  templateUrl: './app-home-page-video.component.html',
  styleUrls: ['./app-home-page-video.component.scss']
})
export class AppHomePageVideoComponent implements OnInit {
  videoLink: string = '';

  constructor(private system: SystemSettingService) {}

  ngOnInit() {
    this.getVideoLink();
  }

  getVideoLink() {
    this.system.apiSystemSettingGet('type==VIDEO').subscribe((res) => {
      if (res.success && res.data.collection.length) {
        this.videoLink = res.data.collection[0].children[0].value;
      }
    });
  }

  openModalVideo() {
    if (this.videoLink) {
      window.open(this.videoLink, '_blank');
    }
  }

}
